/**
 * ч.752/790: стаття ДДС за типом операції банку — коди системних статей
 * платформи (0476). Спільно для редактора платіжки і розбору виписки.
 */
export const CFI_BY_OP: Record<string, string> = {
  FROM_BUYER: 'OP_SALES', CARD_RECEIPT: 'OP_SALES', FROM_BANK: 'OP_OTHER_IN',
  LOAN: 'FIN_LOAN_IN', OTHER: '', CAPITAL_CONTRIBUTION: 'FIN_CAPITAL',
  TO_SUPPLIER: 'OP_SUPPLIERS', TO_BANK: 'OP_BANK_FEES', TAX: 'OP_OTHER_TAX',
  SALARY: 'OP_SALARY', LOAN_RETURN: 'FIN_LOAN_OUT', CARD_PAYMENT: 'OP_SUPPLIERS',
  REFUND_TO_BUYER: 'OP_REFUND_OUT', REFUND_FROM_SUPPLIER: 'OP_REFUND_IN', TO_PODOTCHET: 'OP_ADVANCE_HOLDER',
  // ч.930 (0523): купівля/продаж валюти і переказ між своїми рахунками — свої
  // системні статті (раніше лишались порожніми; лише «Інше» — вручну).
  CURRENCY_EXCHANGE: 'OP_FX_EXCHANGE', TRANSFER_OWN: 'OP_TRANSFER_OWN',
  // ч.933: надані позики — інвестиційна діяльність.
  LOAN_GIVEN: 'INV_LOAN_GIVEN', LOAN_GIVEN_RETURN: 'INV_LOAN_RETURNED',
  // ч.941: транзит комісії/доручення — операційна діяльність, «інші».
  TRANSIT_IN: 'OP_OTHER_IN', TRANSIT_OUT: 'OP_OTHER_OUT',
  // ч.1133 (0577): власні кошти підприємця (лише ФОП) — фінансова діяльність.
  OWNER_WITHDRAWAL: 'FIN_OWNER_OUT', OWNER_CONTRIBUTION: 'FIN_OWNER_IN',
};

/**
 * ч.1133: види «власні кошти підприємця» є лише в організації-ФОП (у юрособи
 * власник отримує гроші дивідендами, зарплатою чи позикою); сервер іншим
 * відмовляє при проведенні. Сторони в них немає — підприємець сам собі.
 */
export const OWNER_FUNDS_OPS = ['OWNER_WITHDRAWAL', 'OWNER_CONTRIBUTION'];

/** Види операцій, доступні організації: для не-ФОП — без «власних коштів підприємця». */
export function opsForOrg<T extends string>(ops: readonly T[], entityType: string | null | undefined): T[] {
  return entityType === 'FOP' ? [...ops] : ops.filter((op) => !OWNER_FUNDS_OPS.includes(op));
}

/** id системної статті ДДС для типу операції ('' — немає авто-статті). */
export function autoCfiId(
  items: { id: string; code?: string | null; is_system?: boolean }[] | undefined,
  op: string,
): string {
  const code = CFI_BY_OP[op];
  if (!code || !items) return '';
  return items.find((x) => x.is_system && x.code === code)?.id ?? '';
}
